
import {locations} from '../constants/locations';


export function getLocationNameById(locNum) {

	if(!locNum) {
		return '';
	}

	switch (locNum) {
    case 1:
      return 'Charlotte';
    case 2:
      return 'Headquarters';
    case 3:
      return 'Birmingham';
    case 4:
      return 'Raleigh';
    case 5:
      return 'Austin';
    case 6:
      return 'Richmond';
    case 7:
      return 'Charleston';
    case 8:
      return 'Oklahoma City';
    case 9:
      return 'Virginia Beach';
    case 10:
      return 'San Antonio';
    case 11:
      return 'Dallas';
    case 12:
      return 'Indianapolis';
    case 13:
      return 'St. Louis';
    case 14:
      return 'Jacksonville';
    case 15:
      return 'Salt Lake City';
    case 16:
      return 'Columbus';
    case 17:
      return 'Cleveland';
    case 18:
      return 'Frisco';
    case 19:
      return 'Kansas City';
    case 20:
      return 'New Orleans';
    case 21:
      return 'Boca Raton';
    default:
      return '';
  }
}

export function getIdByLocation(locationDisplay) {
	switch (locationDisplay) {
    case 'Charlotte':
      return 1;
    case 'Headquarters':
      return 2;
    case 'Birmingham':
      return 3;
    case 'Raleigh':
      return 4;
    case 'Austin':
      return 5;
    case 'Richmond':
      return 6;
    case 'Charleston':
      return 7;
    case 'Oklahoma City':
      return 8;
    case 'Virginia Beach':
      return 9;
    case 'San Antonio':
      return 10;
    case 'Dallas':
      return 11;
    case 'Indianapolis':
      return 12;
    case 'St. Louis':
      return 13;
    case 'Jacksonville':
      return 14;
    case 'Salt Lake City':
      return 15;
    case 'Columbus':
      return 16;
    case 'Cleveland':
      return 17;
    case 'Frisco':
      return 18;
    case 'Kansas City':
      return 19;
    case 'New Orleans':
      return 20;
    case 'Boca Raton':
      return 21;
    default:
      return '';
  }
}

export function getStoreByNumber(locNum) {

  console.log(locNum);
  console.log(locations);

  for(let i = 0; i < locations.length; i++) {
    if(locations[i].number == parseInt(locNum)) {
      return locations[i];
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/stores.jsx